module.exports = __webpack_public_path__ + "static/media/2023.aaf09edc.png";